import { Utils } from "@lightningjs/sdk";
export const watchAsset = (name) => Utils.asset(`images/watch-details/${name}`);
export const watchText = (text, fontSize, w, fontFace = "Insatiable Display") => ({
    text,
    fontFace,
    fontStyle: fontFace === "Staff Wide" || fontFace === "Insatiable Display"
        ? "700"
        : "400",
    fontSize,
    precision: 1,
    lineHeight: fontSize * 1.289,
    textColor: 0xffffffff,
    textAlign: "center",
    verticalAlign: "middle",
    w,
    wordWrap: false,
});
export const WATCH_PANEL_WIDTH = 1347;
export const WATCH_BLUE = 0xff085fff;
export const WATCH_PINK = 0xfffe80e0;
export const WATCH_GOLD = 0xffdeba37;
export const WATCH_DARK = 0xff161616;
export const WATCH_GLASS = {
    radius: 24,
    bezelWidth: 37,
    thickness: 37,
    refraction: 0.8,
    blur: 21,
    dispersion: 0.5,
    lightAngle: -45,
    lightIntensity: 0.8,
    rimWidth: 1,
    rimOpacity: 0.2,
};
//# sourceMappingURL=styles.js.map